/**
 * @desc 增加安防公告
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AnnouncementNoticeAddRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/announcement/add',
    data,
  });
}

export function mock(
  data: defs.AnnouncementNoticeAddRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/announcement/add',
    data,
  });
}
